export default function inventoryStateManager() {
  let instance = null;
  function createInstance() {
    let inventory = getPrototypeInventory();
    function getPrototypeInventory() {
      return {
        sugar: 0,
        boxes: 20,
        lids: 0,
        nucBoxes: 0,
        treatments: { acidPads: 0, acidVapors: 0, synthetic: 0 },
        packages: [],
        nucs: [],
        queens: [],
        splits: [],
        honeyExtractors: ["smallExtractor"],
        harvestedHoney: 0,
        filledJars: 10,
        buckets: 0,
        honeyStand: { lastMutated: null, jars: 0, coins: 0 },
      };
    }
    return {
      addInventoryItem: (value) => {
        console.log("setting hive state: ", value);
        inventory.push(value);
      },
      setInventory: (value) => {
        if (!value) {
          inventory = getPrototypeInventory();
        } else {
          console.log("setting inventory state: ", value);
          inventory = value;
        }
      },
      getInventory: () => {
        return inventory;
      },
    };
  }
  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}
